import { AbstractFWSiteParams } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFWSiteParams';
import { IFWSiteParamsArgument } from 'tag/ts/tag/interfaces/arguments/IFWSiteParamsArgument';
import { AdSetupDefinition } from 'tag/ts/tag/model/type/ads/AdSetupDefinition';
import { TFWSiteParams } from 'tag/ts/tag/types/ads/freewheel/TFWSiteParams';

/**
 * @copyright © Paramount Streaming
 * @description Freewheel site parameters for streaming ads
 */
export class FWSiteParams extends AbstractFWSiteParams {

	/**
	 * @description Internal store for site ad parameters
	 * @type {TFWSiteParams}
	 * @readonly
	 */
	protected readonly adParams: TFWSiteParams;

	constructor( argument: IFWSiteParamsArgument ) {
		super(
			{
				name: 'FWSiteParams',
				...argument
			}
		);

		switch ( argument?.adSetupInfo?.setup?.definition ) {
			case AdSetupDefinition.IMA:
				this?.logger?.log( 'AdSetupDefinition = IMA' );
				this.adParams = this.appendFMSData( this.createIMAParams() );
				break;
			case AdSetupDefinition.DAI_SDK:
				this?.logger?.log( 'AdSetupDefinition = DAI_SDK' );
				this.adParams = this.appendFMSData( this.createDAISDKParams() );
				break;
			case AdSetupDefinition.DAI_SSB:
				this?.logger?.log( 'AdSetupDefinition = DAI_SSB' );
				this.adParams = this.appendFMSData( this.createDAISSBParams() );
				break;
			case AdSetupDefinition.DAI_API:
				this?.logger?.log( 'AdSetupDefinition = DAI_API' );
				this.adParams = this.createDAIAPIParams();
				break;
			case AdSetupDefinition.LINEAR_AD_TRACKING:
				this?.logger?.log( 'AdSetupDefinition = LINEAR_AD_TRACKING' );
				this.adParams = this.createLinearParams();
				break;
		}
	}

	/**
	 * @description Returns site parameters for streaming ads
	 * @returns {TFWSiteParams}
	 */
	get adParameters(): TFWSiteParams {
		return this.adParams;
	}
}